<app-handler-items
    (listItemComplete)="saveOutput($event)"
    (comboItemLength)="itemLenght($event)"
    [itemsData]="resourcesRequest"
    [workOrderData]="workOrder"
    [addNewItem]="false"
    [addProvider]="false"
    [titleDialog]="'Salida'"
    [addCurrentAmount]="true"
    [replyRoute]="'almacen/salidas_inventario'"
    [urlItemCombo]="urlGetItemsForOutputs"
    [fromPackOff]="fromPackOff"
    [comboWorkOrder]="true"
    [workOrderState]="workOrderState">
</app-handler-items>
